import React from "react";

import RfidProductTagger from "../components/rfid/product-tagger";

class RfidTagProductPage extends React.Component{

    render(){
        return(
            <div style={{ padding: 10 }}>
                <RfidProductTagger/>
            </div>
        );
    }

    

}

export default RfidTagProductPage;


// WEBPACK FOOTER //
// ./src/containers/rfid-tag-product.js